import React from 'react';
import { useIsRequiredElement } from '../../../hook/useIsRequiredElement';
import { GridYValue, GridYUnit } from '../../../constants';
import ElementErrorMessage from './components/element-error-message';

export const PhoneElement = function FromElement({ element, handlerChange, error, formHasOnlyOneSubmitter }) {
  const isRequiredElement = useIsRequiredElement(element, formHasOnlyOneSubmitter);
  return (
    <>
      <label
        htmlFor={element.id}
        className="form-label"
        style={{ zIndex: 5000 + (element.options.zIndex || 10), width: 'fit-content', position: 'relative' }}
      >
        {element.options.label} <span className="required">{isRequiredElement ? '*' : ''}</span>
      </label>
      <input
        name={element.options.name}
        id={element.id}
        type="tel"
        className={`form-control form-control-${element.options.size}`}
        value={element.options.valueInput}
        style={{
          height: element.options.innerElemHeight * GridYValue + GridYUnit,
          zIndex: 5000 + (element.options.zIndex || 10),
          position: 'relative',
          width: '100%',
          minHeight: 'unset',
        }}
        onChange={(e) => handlerChange(element, e.target.value)}
        readOnly={element.options.readOnly}
      />
      <ElementErrorMessage message={error} />
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </>
  );
};
